import { stringify } from 'hub-http/helpers/params';
import enviro from 'enviro';
import { isEmpty } from '../utils/object';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { PinIcon } from 'foundations-assets/icons/components/PinIcon';
import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubPickerRow = ({
  account,
  isDefault,
  onDefaultChange,
  pinned,
  onPinChange,
  redirectTo,
  query,
  hasDemoPortalGate = false,
  validationResult,
  onGenerateDemoDataClick
}) => {
  var _account$hublet;
  const {
    accountName,
    id,
    appDomain,
    domain
  } = account;
  const getRedirectUrl = () => {
    let redirectUrl = redirectTo(id, appDomain);
    if (!isEmpty(query)) {
      redirectUrl += `${redirectUrl.indexOf('?') === -1 ? '?' : '&'}${stringify(query)}`;
    }
    return redirectUrl;
  };
  const handleRowClick = e => {
    if (e.metaKey) {
      window.open(getRedirectUrl());
    } else {
      window.location.href = getRedirectUrl();
    }
  };
  const onOpenButtonClick = e => {
    window.open(getRedirectUrl());
    e.stopPropagation();
  };
  const onDefaultButtonClick = e => {
    onDefaultChange(account.id);
    e.stopPropagation();
  };
  const onPinButtonClick = e => {
    onPinChange(account.id);
    e.stopPropagation();
  };
  const handleGenerateDemoDataClick = e => {
    onGenerateDemoDataClick(account.id);
    e.stopPropagation();
  };
  const accountNameOrId = accountName || id;
  return /*#__PURE__*/_jsxs(View, {
    as: "tr",
    cursor: "pointer",
    onClick: handleRowClick,
    children: [/*#__PURE__*/_jsx(TableHoverCell, {
      "data-test-id": `hub-picker-name-cell-${account.id}`,
      hoverContent: /*#__PURE__*/_jsxs("span", {
        children: [hasDemoPortalGate && enviro.ifHublet({
          isNa1: () => true,
          isNonNa1: () => false
        }, (_account$hublet = account.hublet) !== null && _account$hublet !== void 0 ? _account$hublet : undefined) && (validationResult === null || validationResult === void 0 ? void 0 : validationResult.isDemoHub) && (validationResult === null || validationResult === void 0 ? void 0 : validationResult.hasSuperAdminAccess) && /*#__PURE__*/_jsxs(Button, {
          onClick: handleGenerateDemoDataClick,
          size: "extra-small",
          use: "tertiary-light",
          "data-test-id": "update-demo-portal-button",
          children: [/*#__PURE__*/_jsx(ArtificialIntelligenceIcon, {}), I18n.text('hubPicker.demoPortalButton')]
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onDefaultButtonClick,
          size: "extra-small",
          use: "tertiary-light",
          children: I18n.text(isDefault ? 'hubPicker.defaultButton.unset' : 'hubPicker.defaultButton.set')
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: "Pinned accounts will appear at the top of your account selection list for easy access",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onPinButtonClick,
            size: "extra-small",
            use: "tertiary-light",
            children: I18n.text(pinned ? 'hubPicker.pinButton.unpin' : 'hubPicker.pinButton.pin')
          })
        }), /*#__PURE__*/_jsxs(Button, {
          onClick: onOpenButtonClick,
          size: "extra-small",
          use: "tertiary-light",
          children: [I18n.text('hubPicker.openButton'), /*#__PURE__*/_jsx(ExternalLinkIcon, {
            size: "100"
          })]
        })]
      }),
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        gap: 12,
        children: [pinned && /*#__PURE__*/_jsx(IconCircle, {
          color: "icon-core-on-fill-default",
          backgroundColor: "fill-accent-light-orange-default",
          icon: PinIcon,
          size: "100"
        }), /*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(Link, {
            href: getRedirectUrl(),
            "data-selenium": "portal-link",
            children: /*#__PURE__*/_jsx(TruncateString, {
              maxWidth: 280,
              children: accountNameOrId
            })
          }), (validationResult === null || validationResult === void 0 ? void 0 : validationResult.latestDdgUpdateTimestamp) && /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "hubPicker.demoPortalLastUpdated",
              options: {
                dateTime: /*#__PURE__*/_jsx(FormattedDateTime, {
                  value: validationResult.latestDdgUpdateTimestamp,
                  format: "lll"
                })
              }
            })
          })]
        }), isDefault && /*#__PURE__*/_jsx(Badge, {
          children: I18n.text('hubPicker.defaultBadge')
        })]
      })
    }), /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx(TruncateString, {
        children: domain
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: id
      })]
    })]
  });
};
export default HubPickerRow;